import _ from 'lodash';
import React from 'react';
import {CoveragesItem, Deduct, Franchise} from '../../containers/coverages/Coverages';
import {colors} from '../../util/colors';
import * as fonts from '../../util/fonts';
import {strings} from '../../util/strings';
import AppSimpleAccordion from '../app-simple-accordion';
import './styles.scss';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { getCurrencyCode } from '../../util/utility';

interface FranchiseCardProps {
  user: any;
  cover: CoveragesItem;
  labels: typeof strings.pt.myCoverages;
  deductData: Deduct
}

const FranchiseCard = ({user, cover, labels, deductData}: FranchiseCardProps) => {
  let headerFont = window.innerWidth <= 550 ? '14px' : '16px';
  const renderFranchiseCardHeader = () => (
    <>
      <p
        style={{
          ...fonts.ML,
          ...fonts.SemiBold,
          color: colors.black,
          fontSize: headerFont,
        }}>
        {labels?.franchise}
      </p>
      <span
        style={{
          ...fonts.ML,
          ...fonts.SemiBold,
          color: colors.black,
          fontSize: headerFont,
          marginLeft: 'auto',
        }}>
        {cover.deductMemAmt} {getCurrencyCode(cover.currency, "myCoverages")}
      </span>
    </>
  );

  const renderFranchiseCardValue = () => (
    <div className="franchise-card-value">
      <div>
        <p style={{...fonts.SM}}>
          {
            deductData?.deductDetails?.find(
              (detail: any) => detail.languageAlias === user.language
            )?.longDescription
          }
        </p>
        <p style={{...fonts.SM}}>
          {labels?.coverDeductType} :{' '}
          <strong>
            {
              deductData?.deductDetails?.find(
                (detail: any) => detail.languageAlias === user.language
              )?.shortDescription
            }
          </strong>
        </p>
      </div>
    </div>
  );

  return (
    <div className="franchise-wrapper">
      <div className="franchise-card">
        <AppSimpleAccordion
          header={renderFranchiseCardHeader()}
          headerClasses="franchise-card-header-description"
          content={renderFranchiseCardValue()}
        />
      </div>
    </div>
  );
};

const mapStateToProps = ({
  user, strings
}: any) => ({
  user: user.value,
  labels: strings.value.pt.myCoverages,
});


export default compose(connect(mapStateToProps)(FranchiseCard));
